import { Panel } from 'react-resizable-panels';
import { LoadingSpinner } from '@repo/atomic-components';
import { AppRoutes } from '@/constants';
import { useGetHistoryRowDetailsQuery } from '@/api/cases';
import { Header } from '@/ui/components/DocumentViewer/VirtualizedPdfViewer/Header.tsx';
import { DetailsViewer } from '@/ui/pages/CasePage/components/DetailsViewer';
import { getCaseFileDisplayLabel } from '@/ui/pages/CasePage/utils/getCaseFileDisplayLabel';

export interface ChatHistoryRowSidePanelProps {
  historyRowId: string;
  matterId: string;
  onClose: () => void;
}

/**
 * Side panel for a citation to a history row with no document, or one whose document can't be
 * previewed. Shows the row's details, like the case files table does.
 */
export function ChatHistoryRowSidePanel({ historyRowId, matterId, onClose }: ChatHistoryRowSidePanelProps) {
  const { data, isLoading, isError } = useGetHistoryRowDetailsQuery({ matterId, historyRowId });
  const title = getCaseFileDisplayLabel({ details: data?.details }, 'Details');

  return (
    <Panel minSize={410} defaultSize="43%">
      <div className="relative flex h-full flex-col overflow-hidden">
        <Header
          documentName={title}
          documentPath={`/${AppRoutes.DocumentViewer}/${historyRowId}`}
          onClose={onClose}
          showOpenInNewTab={false}
        />
        <div className="flex min-h-0 flex-1 flex-col pt-14">
          {isLoading && <LoadingSpinner className="flex-1" size={48} />}
          {!isLoading &&
            (isError && !data ? (
              <div className="text-theme-text-grey flex flex-1 items-center justify-center px-8 py-10 text-sm">
                These details could not be loaded. Please try again.
              </div>
            ) : (
              <DetailsViewer details={data?.details} />
            ))}
        </div>
      </div>
    </Panel>
  );
}
